import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useNavigate, useParams } from 'react-router-dom';

import AxiosApiClient from '../../utils/AxiosApiClient';
import AuthUtility from './AuthUtility';
import LoadingSpinner from '../LoadingSpinner';

//import axios from 'axios';
import swal from 'sweetalert';

function ActivateAccount() {

	const navHistory = useNavigate();

	//for all API calls
	const auth_api = 'phpLaravel';
	if (localStorage.getItem('auth_api') && localStorage.getItem('auth_api') !== '') {
		auth_api = localStorage.getItem('auth_api');
	}

	// using hooks
	const [isLoading, setIsLoading] = React.useState(false);
	const [isMounted, setIsMounted] = useState(false);
	const [isActivated, setIsActivated] = useState(false);
	const [accountNavPath, setAccountNavPath] = useState('');
	const [authRole, setAuthRole] = useState(
		AuthUtility.isLoggedIn() ? localStorage.getItem('auth_role') : null
	);

	const { id } = useParams();

	//initial call to activate account
	useEffect(() => {

		setIsLoading(true);

		if (isMounted) {

			const fetchApiData = async () => {
				try {
					const { apiClient, getBearerToken, makeRequestWithHeaders } = AxiosApiClient({ apiBackend: auth_api, token: localStorage.getItem('auth_token') });
					await getBearerToken();
					const response = await makeRequestWithHeaders('put', '/api/activate_account/' + id, null, {});

					setApiData(response, "ActivateAccount.useEffect");
				} catch (error) {
					handleApiError(error, "ActivateAccount.useEffect");
				}
			};
			fetchApiData();

		} else {
			setIsMounted(true);
		}

	}, [isMounted, id, navHistory]);

	function setApiData(response, theFunction) {
		if (response && response.data) {
			if (response.data.status === 200) {//HTTP_OK
				console.log(theFunction + ': ', response.data.message);

				AuthUtility.setAuthData(response.data.auth_first_name, response.data.auth_last_name, response.data.auth_email,
					response.data.auth_token, response.data.auth_role, response.data.auth_app, response.data.auth_paypal_email, response.data.auth_paypal_merchant_id,
					null, null);

				if (localStorage.getItem('auth_role') === 'super_admin' || localStorage.getItem('auth_role') === 'admin'
					|| localStorage.getItem('auth_role') === 'support_agent' || localStorage.getItem('auth_role') === 'member'
					|| localStorage.getItem('auth_role') === 'creator' || localStorage.getItem('auth_role') === 'collaborator') {
					//setAccountNavPath('/' + localStorage.getItem('auth_role') + '/account');
					navHistory('/' + localStorage.getItem('auth_role') + '/account');
					swal("Success", "Your Account has been successfully activated", "success");
				}

				setIsActivated(true);

			} else if (response.data.status === 401 || response.data.status === 404) {//HTTP_UNAUTHORIZED OR HTTP_NOT_FOUND
				console.log(theFunction + ' error: ', response.data.message + ' back-end api call error');

				//user not authenticated on server so remove from local storage
				AuthUtility.clearAuthData();

				setIsLoading(false);
				swal("Warning", response.data.message + ' Can not activate account. Please click on the link in your email after registering.', "warning");
				navHistory('/login');

			} else {//more errors

			}
		}

		setIsLoading(false);
	}
	function handleApiError(error, theFunction) {
		console.log(theFunction + ' error: ', error + ' back-end api call error');

		//user not authenticated on server so remove from local storage
		AuthUtility.clearAuthData();
		setIsLoading(false);
		swal("Error", error, "error");
		navHistory('/login');
	}

	function capitalizeFirstLetter(str) {
		if (str.length === 0) {
			return ""; // Handle empty strings
		}
		return str.charAt(0).toUpperCase() + str.slice(1);
	}

	return (
		<div className={`body-content bg-fff pt-70l-110m-50s ${authRole === null || authRole === '' ? 'pb-160l-125s' : 'pb-220l-180s'}`}>

			<div className="panel large pt-20l-10s">
				<div className="grid-x bb1-555 pb-5">
					<div className="large-12 medium-12 small-12 cell">
						<span className="font-orbitron font-size-24 font-weight-800 uppercase italic">Account</span>
					</div>
				</div>
			</div>
			{isLoading && (
				<div className="panel large pt-20l-10s">
					<div className="grid-x">
						<div className="large-12 medium-12 small-12 cell text-center">
							<LoadingSpinner paddingclassName="" />
						</div>

					</div>
				</div>
			)}

		</div>
	);
}

export default ActivateAccount;